var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.372507 8.09227C-0.124169 8.59433 -0.124169 9.40968 0.372507 9.91175L8.00145 17.6235C8.49813 18.1255 9.30473 18.1255 9.80141 17.6235C10.2981 17.1214 10.2981 16.306 9.80141 15.804L3.07045 9L9.79743 2.19603C10.2941 1.69396 10.2941 0.878612 9.79743 0.376548C9.30076 -0.125516 8.49415 -0.125516 7.99748 0.376548L0.368534 8.08825L0.372507 8.09227Z",
    fill: "#BF96FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98121 8.09227C8.48453 8.59433 8.48453 9.40968 8.98121 9.91175L16.6102 17.6235C17.1068 18.1255 17.9134 18.1255 18.4101 17.6235C18.9068 17.1214 18.9068 16.306 18.4101 15.804L11.6792 9L18.4061 2.19603C18.9028 1.69396 18.9028 0.878612 18.4061 0.376548C17.9095 -0.125516 17.1029 -0.125516 16.6062 0.376548L8.97724 8.08825L8.98121 8.09227Z",
    fill: "#BF96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.79f6def8963adf19c9e7554c71f5d917.svg";
export { ForwardRef as ReactComponent };